import { render } from "./EditYearModal.vue?vue&type=template&id=dd240528"
import script from "./EditYearModal.vue?vue&type=script&lang=ts"
export * from "./EditYearModal.vue?vue&type=script&lang=ts"
script.render = render

export default script